import { formatText, formatDateString } from "bernie-l10n";
import { CheckPricesLocalizationProps, DealProps } from "./typings";
import { isPolygon } from "src/components/utility/LocationUtils";
import { Deal } from "src/typings/microserviceModels/check-prices-flex-module";

// Localization utils
export const modelKeyToDealTextMap = {
  bestWeekend: () => formatText("checkPrices.title.bestDeal"),
  today: () => formatText("checkPrices.title.today"),
  tomorrowNight: () => formatText("checkPrices.title.tomorrowNight"),
  thisWeekend: () => formatText("checkPrices.title.thisWeekend"),
  nextWeekend: () => formatText("checkPrices.title.nextWeekend")
};

export const a11yKeyToTextMap = {
  bestWeekend: getLocalizationKey.bind(null, "bestDeal"),
  today: getLocalizationKey.bind(null, "today"),
  tomorrowNight: getLocalizationKey.bind(null, "tomorrowNight"),
  thisWeekend: getLocalizationKey.bind(null, "thisWeekend"),
  nextWeekend: getLocalizationKey.bind(null, "nextWeekend")
};

function getLocalizationKey(
  key: string,
  { regionName, datesLabel, regionType }: CheckPricesLocalizationProps
) {
  const shouldUseNearPreposition = !isPolygon(regionType);
  const closeTo = shouldUseNearPreposition ? ".closeTo" : "";

  return formatText(`checkPrices.title.${key}.title${closeTo}`, regionName, datesLabel);
}

// Functional Utils
export function buildDatesLabel(start: string, end: string): string {
  const formatDate = (date: string) => formatDateString(date, { skeleton: "MMMd" });

  return start && end ? `${formatDate(start)} - ${formatDate(end)}` : "";
}

export function getContent({ modelKey, model }: Pick<DealProps, "modelKey" | "model">): Deal {
  if (modelKey === "tomorrowNight") {
    const today = new Date();
    const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);
    const afterTomorrow = new Date(today.getTime() + 48 * 60 * 60 * 1000);
    const todayLink = model["today"].link; // grabs dateless

    return {
      link: `${todayLink}&startDate=${formatDateString(tomorrow, { raw: "yyyy-MM-dd" })}`,
      label: "", // this gets built later on using end and start dates. It's never used
      isoEndDate: formatDateString(afterTomorrow, { raw: "yyyy-MM-dd" }),
      isoStartDate: formatDateString(tomorrow, { raw: "yyyy-MM-dd" })
    };
  }

  if (modelKey === "today") {
    const today = new Date();
    const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000);

    return {
      ...model[modelKey],
      isoStartDate: formatDateString(today, { raw: "yyyy-MM-dd" }),
      isoEndDate: formatDateString(tomorrow, { raw: "yyyy-MM-dd" })
    };
  }

  return model[modelKey];
}

export function getLink(content: Deal, modelKey: string) {
  const link = content.link;

  return modelKey === "today" ? `${link}&startDate=${content.isoStartDate}` : link;
}
